import React from 'react'

interface SupportProps {
  size?: number
  color?: string
}

export const Support: React.FC<SupportProps> = ({
  size = 24,
  color = 'white',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="call">
        <path
          id="Vector"
          d="M18.8123 8.87202C18.5553 5.35802 15.5983 2.57202 11.9983 2.57202C8.39831 2.57202 5.44131 5.35802 5.18431 8.87202C3.68431 9.21502 2.57031 10.501 2.57031 12.001C2.57031 13.501 3.68431 14.787 5.18431 15.129C5.44131 18.644 8.39831 21.429 11.9983 21.429H13.7133C14.1866 21.429 14.5703 21.0453 14.5703 20.572C14.5703 20.0987 14.1866 19.715 13.7133 19.715H11.9983C9.17031 19.715 6.85531 17.401 6.85531 14.572V9.43002C6.85531 6.60202 9.17031 4.28802 11.9983 4.28802C14.8273 4.28802 17.1413 6.60202 17.1413 9.43002V14.359C17.1421 14.5861 17.2326 14.8036 17.3932 14.9641C17.5537 15.1247 17.7713 15.2152 17.9983 15.216C19.8843 15.216 21.4273 13.759 21.4273 12.002C21.4273 10.502 20.3133 9.21602 18.8133 8.87302L18.8123 8.87202ZM4.28431 12.001C4.28431 11.444 4.62731 10.972 5.14131 10.715V13.287C4.62731 13.029 4.28431 12.558 4.28431 12.001ZM18.8553 13.287V10.715C19.3703 10.972 19.7133 11.444 19.7133 12.001C19.7133 12.558 19.3703 13.029 18.8553 13.287Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
